import { Stack } from '@mui/material';
import {
  IWsChatBubbleProps,
  WsChatBubble,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
} from 'wisestep-base';

export interface ISmsLogsZoomChatBubble {
  message: string;
  recruiterName: string;
  onClick: () => void;
}

const SmsLogsZoomChatBubble = ({
  direction,
  message,
  recruiterName,
  onClick,
}: IWsChatBubbleProps & ISmsLogsZoomChatBubble) => (
  <WsChatBubble sx={{ minWidth: 500 }} direction={direction}>
    <WsTypography variant={WsTypoVariants.BODY1}>{message}</WsTypography>
    <Stack alignItems={'flex-end'}>
      <WsTypography>Recruiter : {recruiterName}</WsTypography>
      <WsTypography onClick={onClick} color={WsTypoColors.PRIMARY} cursor={'pointer'}>
        App: ZOOM
      </WsTypography>
    </Stack>
  </WsChatBubble>
);

export default SmsLogsZoomChatBubble;
